import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=46a0d17a&scoped=true"
import script from "./Badge.vue?vue&type=script&lang=ts"
export * from "./Badge.vue?vue&type=script&lang=ts"
import style0 from "./Badge.vue?vue&type=style&index=0&id=46a0d17a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a0d17a",
  null
  
)

export default component.exports